import React, { Component } from 'react'
import { message } from 'antd'

import history from '../../history'

export const ERROR_PATH = '/error'

class ErrorBoundary extends Component {
  state = {
    hasError: false,
  }

  static getDerivedStateFromError() {
    return { hasError: true }
  }

  componentDidCatch(error, errorInfo) {
    console.error('Uncaught error:', error, errorInfo)
    message.error('Algo deu errado')

    if (history.location.pathname !== ERROR_PATH) {
      history.push(ERROR_PATH)
    }

    this.setState({ hasError: false })
  }

  render() {
    if (this.state.hasError) {
      return (
        <div style={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          minHeight: '100vh',
          padding: 24,
          textAlign: 'center',
        }}
        >
          <h2>Algo deu errado</h2>
          <p>Redirecionando...</p>
        </div>
      )
    }

    return this.props.children
  }
}

export default ErrorBoundary
